module.exports = __webpack_public_path__ + "static/media/redUnlock.444de51d.svg";